import { render } from "./PengaduanNasabah.vue?vue&type=template&id=b7420712"
import script from "./PengaduanNasabah.vue?vue&type=script&lang=js"
export * from "./PengaduanNasabah.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__